import React from 'react';
import { Dialog, DialogTitle, DialogBody, DialogActions } from './catalyst/dialog';
import { Button } from './catalyst/button';
import { KEYBOARD_SHORTCUTS } from '../utils/keyboardShortcuts';

export default function KeyboardShortcutsHelp({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} size="sm">
      <DialogTitle>Keyboard shortcuts</DialogTitle>
      <DialogBody>
        <ul className="divide-y divide-zinc-100">
          {KEYBOARD_SHORTCUTS.map((item) => (
            <li key={item.keys} className="flex items-center justify-between gap-4 py-2">
              <span className="text-sm text-zinc-700">{item.action}</span>
              <kbd className="rounded-md bg-zinc-100 px-2 py-1 text-xs font-medium text-zinc-700 ring-1 ring-inset ring-zinc-200">
                {item.keys}
              </kbd>
            </li>
          ))}
        </ul>
      </DialogBody>
      <DialogActions>
        <Button plain onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
